import { IconTruck, IconTableImport, IconUsers, IconFileInvoice } from '@tabler/icons-react';
import { WelcomeExtensions } from '@ayocore/platform/client/components/Welcome/WelcomeExtensions';

/**
 * Регистрация Grasias навигационных карточек на WelcomePage.
 */
export function registerGrasiasWelcomeExtensions(): void {
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'grasias-order-docs',
    label: 'Заказы 1С',
    icon: IconFileInvoice,
    url: '/accounting/order-docs',
    order: 30,
  }));
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'grasias-crm-leads',
    label: 'Лиды',
    icon: IconUsers,
    url: '/crm/leads',
    order: 31,
  }));
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'accounting-supplier-docs',
    label: 'Документы поставщиков',
    icon: IconTruck,
    url: '/accounting/supplier-docs',
    order: 35,
  }));
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'grasias-contractor-docs',
    label: 'Таблицы подрядчиков',
    icon: IconTableImport,
    url: '/grasias/contractor-docs',
    order: 40,
  }));
}
